export default __webpack_public_path__ + "95fe248bc89107478e021f9775f08396.png";